// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testscn.screen {
  width: 100%;
  max-width: 1180px;
  height: 100vh;
  height: 100dvh;
}

.testscn__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px clamp(16px, 3vw, 32px) calc(env(safe-area-inset-bottom, 0px) + 28px);
}

.testscn__groups {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.testscn__group {
  min-width: 0;
}

.testscn__group-head {
  margin-bottom: 12px;
}

.testscn__group-head h2 {
  margin: 0;
  padding: 0;
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.15;
}

.testscn__group-head p {
  max-width: 70ch;
  margin: 4px 0 0;
  color: var(--palette-text-muted);
  font-size: 0.84rem;
  line-height: 1.4;
}

.testscn__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr));
  gap: 12px;
}

.testscn__row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  min-height: 96px;
  padding: 14px 16px;
  border: 1px solid var(--palette-border);
  border-radius: 14px;
  color: inherit;
  background: var(--palette-surface);
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.testscn__row:hover {
  border-color: var(--palette-border-strong);
}

.testscn__row:focus-visible {
  outline: 3px solid var(--palette-secondary);
  outline-offset: 2px;
}

.testscn__row--current {
  border-color: var(--palette-secondary);
  background: var(--palette-surface-blue-soft);
}

.testscn__text {
  flex: 1;
  min-width: 0;
}

.testscn__label {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.2;
}

.testscn__desc {
  margin-top: 4px;
  color: var(--palette-text-muted);
  font-size: 0.82rem;
  line-height: 1.4;
}

.testscn__chev {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  color: var(--palette-text-muted);
}

.testscn__current {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  color: var(--palette-secondary);
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}

.testscn__current svg {
  width: 16px;
  height: 16px;
}

.testscn__foot {
  margin-top: 28px;
  color: var(--palette-text-muted);
  font-size: 0.8rem;
}

.testscn__foot code {
  padding: 1px 5px;
  border: 1px solid var(--palette-border);
  border-radius: 5px;
  background: var(--palette-surface);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.78rem;
}

@media (max-width: 520px) {
  .testscn__groups {
    gap: 26px;
  }

  .testscn__row {
    min-height: 0;
    padding: 13px 14px;
  }

  .testscn__current {
    align-self: flex-start;
    margin-top: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/testScenariosScreen.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,kCAAkC;EAClC,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF","sourcesContent":[".testscn.screen {\n  width: 100%;\n  max-width: 1180px;\n  height: 100vh;\n  height: 100dvh;\n}\n\n.testscn__content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px clamp(16px, 3vw, 32px) calc(env(safe-area-inset-bottom, 0px) + 28px);\n}\n\n.testscn__groups {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.testscn__group {\n  min-width: 0;\n}\n\n.testscn__group-head {\n  margin-bottom: 12px;\n}\n\n.testscn__group-head h2 {\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-display);\n  font-size: 1.25rem;\n  font-weight: 600;\n  line-height: 1.15;\n}\n\n.testscn__group-head p {\n  max-width: 70ch;\n  margin: 4px 0 0;\n  color: var(--palette-text-muted);\n  font-size: 0.84rem;\n  line-height: 1.4;\n}\n\n.testscn__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr));\n  gap: 12px;\n}\n\n.testscn__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-width: 0;\n  min-height: 96px;\n  padding: 14px 16px;\n  border: 1px solid var(--palette-border);\n  border-radius: 14px;\n  color: inherit;\n  background: var(--palette-surface);\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.testscn__row:hover {\n  border-color: var(--palette-border-strong);\n}\n\n.testscn__row:focus-visible {\n  outline: 3px solid var(--palette-secondary);\n  outline-offset: 2px;\n}\n\n.testscn__row--current {\n  border-color: var(--palette-secondary);\n  background: var(--palette-surface-blue-soft);\n}\n\n.testscn__text {\n  flex: 1;\n  min-width: 0;\n}\n\n.testscn__label {\n  font-family: var(--font-display);\n  font-size: 1.05rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.testscn__desc {\n  margin-top: 4px;\n  color: var(--palette-text-muted);\n  font-size: 0.82rem;\n  line-height: 1.4;\n}\n\n.testscn__chev {\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  color: var(--palette-text-muted);\n}\n\n.testscn__current {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 4px;\n  color: var(--palette-secondary);\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.testscn__current svg {\n  width: 16px;\n  height: 16px;\n}\n\n.testscn__foot {\n  margin-top: 28px;\n  color: var(--palette-text-muted);\n  font-size: 0.8rem;\n}\n\n.testscn__foot code {\n  padding: 1px 5px;\n  border: 1px solid var(--palette-border);\n  border-radius: 5px;\n  background: var(--palette-surface);\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 0.78rem;\n}\n\n@media (max-width: 520px) {\n  .testscn__groups {\n    gap: 26px;\n  }\n\n  .testscn__row {\n    min-height: 0;\n    padding: 13px 14px;\n  }\n\n  .testscn__current {\n    align-self: flex-start;\n    margin-top: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
